import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

// Rutas públicas que SIEMPRE deben verse en tema oscuro,
// independientemente de la preferencia guardada del usuario.
const PUBLIC_PATHS = ['/', '/landing', '/contact', '/curso', '/login', '/ceo-login', '/privacy-policy', '/terms-of-service'];

const isPublicPath = () => {
  if (typeof window === 'undefined') return false;
  return PUBLIC_PATHS.includes(window.location.pathname);
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : true; // Default to dark
  });

  useEffect(() => {
    // Save theme preference (siempre persistimos la preferencia del usuario)
    localStorage.setItem('theme', isDark ? 'dark' : 'light');

    // En rutas públicas (landing/login/etc.) FORZAMOS tema oscuro.
    // El AppRoutes ya escucha cambios de path para reaplicar este criterio.
    const forceDark = isPublicPath();
    const root = document.documentElement;
    if (isDark || forceDark) {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.add('light');
      root.classList.remove('dark');
    }
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
